import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CroodsProvider } from 'croods'
import { authHeaders, saveHeaders } from 'croods-auth'
import { isDev } from '@seasonedsoftware/utils'
import get from 'lodash/get'

import FormError from 'forms/FormError'
import Loading from 'ui/Loading'
import useCroodsAuthStorage from 'auth/useCroodsAuthStorage'

const CustomCroodsProvider = ({ children, ...props }) => {
  const authStorage = useCroodsAuthStorage()
  const [baseUrl, setBaseUrl] = useState(
    get(authHeaders(authStorage), 'Access-Token')
      ? process.env.REACT_APP_HEROKU_URL
      : process.env.REACT_APP_API_URL,
  )

  return (
    <CroodsProvider
      handleResponseHeaders={response => {
        get(response, 'headers.access-token') &&
          baseUrl !== process.env.REACT_APP_HEROKU_URL &&
          setBaseUrl(process.env.REACT_APP_HEROKU_URL)

        saveHeaders(response, authStorage)
      }}
      baseUrl={baseUrl}
      debugRequests={isDev()}
      debugActions={isDev()}
      headers={authHeaders(authStorage)}
      renderLoading={Loading}
      renderError={error => <FormError>{error}</FormError>}
      requestTimeout={30000}
      {...props}
    >
      {children}
    </CroodsProvider>
  )
}

CustomCroodsProvider.propTypes = {
  children: PropTypes.element.isRequired,
}

export default CustomCroodsProvider
